module.exports = __webpack_public_path__ + "static/tbg-9cdf6eb91f81443a1c65b220584039c1.png";